export const MINIMUM_REDEEMING_DISPLAY_MS = 800;

interface FinalizeOrgRedemptionOpts {
  successRoute: string;
  navigate: (route: string) => void;
  refreshPurchaseState: () => Promise<void>;
  isSessionCurrent: () => boolean;
  minimumLoadingMs?: number;
  wait?: (milliseconds: number) => Promise<void>;
}

interface FinalizeOrgRedemptionResult {
  sessionCurrent: boolean;
  refreshError: unknown | null;
}

const defaultWait = (milliseconds: number) =>
  new Promise<void>((resolve) => setTimeout(resolve, milliseconds));

export async function finalizeOrgRedemption({
  successRoute,
  navigate,
  refreshPurchaseState,
  isSessionCurrent,
  minimumLoadingMs = MINIMUM_REDEEMING_DISPLAY_MS,
  wait = defaultWait,
}: FinalizeOrgRedemptionOpts): Promise<FinalizeOrgRedemptionResult> {
  // Enter the gate-exempt destination before refreshed paid access can trigger
  // profile-completion routing. The root dialog masks this route while loading.
  navigate(successRoute);

  const refreshResult = refreshPurchaseState()
    .then(() => ({ ok: true as const }))
    .catch((error: unknown) => ({ ok: false as const, error }));

  const [result] = await Promise.all([
    refreshResult,
    wait(minimumLoadingMs),
  ]);

  if ("error" in result) {
    return {
      sessionCurrent: isSessionCurrent(),
      refreshError: result.error,
    };
  }

  return {
    sessionCurrent: isSessionCurrent(),
    refreshError: null,
  };
}
